export default __webpack_public_path__ + "397af688e64e2af829d2e515386a2177.wav";